export default __webpack_public_path__ + "static/tenalphas-moving-content-ece9685a3343de1a4d1025af978095b4.jpg";